import React from 'react';

export interface FormBuilderContextProps {
  onLearnMoreClick?: (url: string) => void;
}
export const FormBuilderContext = React.createContext<FormBuilderContextProps>({
  onLearnMoreClick: () => ({}),
});
